import React, { FC } from "react";
import { Flex, BoxProps } from "src/ccl/layout";
import { styled } from "src/ccl/stitches";

const Main = styled("main", {
  flex: "1 0 auto",
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
});

export interface PageProps extends BoxProps {
  workspace?: boolean;
  header?: React.ReactNode;
  title?: string;
  children?: React.ReactNode;
  /**
   * The footer this page renders; pass null for no footer. Deliberately
   * required with no default — a silent fallback to the legacy footer is
   * how five marketing pages shipped with the wrong footer (see
   * docs/solutions/logic-errors/
   * marketing-pages-fullheaderpage-silently-falls-back-to-legacy-footer-2026-08-23.md).
   */
  FooterComponent: FC | null;
}

export const Page = ({
  header = null,
  children,
  FooterComponent,
  workspace = false,
  ...boxProps
}: PageProps) => (
  <Flex
    css={{
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "stretch",
      minHeight: "100vh",
      ...(workspace && { "@workspace": { height: "100dvh" } }),
    }}
    {...boxProps}
  >
    {header}

    <Main
      css={
        workspace
          ? { "@workspace": { flex: "1 0 0", minHeight: "auto" } }
          : undefined
      }
    >
      {children}
    </Main>
    {FooterComponent && <FooterComponent />}
  </Flex>
);
